var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{
      'html-fullscreen': _vm.isFullscreen,
      'html-fullscreen-keyboard': _vm.showKeyboard && _vm.isFullscreen,
    },attrs:{"id":"screen_container"}},[_c('canvas',{staticClass:"game-canvas",attrs:{"id":"canvas","oncontextmenu":"event.preventDefault()"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }